<template>
  <b-row>
    <b-col cols="12">
      <form-step />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormStep from './FormStep.vue'

export default {
  components: {
    BRow,
    BCol,
    FormStep,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
